// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3379":"f1310985","5038":"a40c080d","8655":"201395c1"}[chunkId] + ".chunk.css";
};